// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  siteURL: 'https://bil.solvezy.com',
  basePath: 'https://apis.solvezy.com/pauth/bil',
  url: 'https://apis.solvezy.com/pauth',
  coreURL: 'https://apis.solvezy.com/wauth/bil',
  region: 'ap-south-1',
  userPoolId: 'ap-south-1_C1qB1qeFw',
  userPoolWebClientId: '3qjqdbko424f9o2rghtlom1ms7',
  code: 'UA-143351251-4',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
